// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #e84200;
  --grey1: #d7d7d7;
  --grey2: #d9d9d9;
  --grey5: #727272;
  --darkgrey3: #000000;
  --white: #ffffff;
  --lightgrey2: #f1f1f1;
  --lightgrey3: #ececec;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: var(--white, #ffffff);
  width: 834px;
  max-width: 90vw;
  border-radius: 0;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
}

.modal-header {
  background: var(--lightgrey2, #f1f1f1);
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 100%;
  height: 138px;
  position: relative;
  border-bottom: none;
}

.modal-header h2 {
  color: var(--darkgrey3, #000000);
  text-align: center;
  font-family: "Inter-Bold", sans-serif;
  font-size: 28px;
  font-weight: 700;
  -webkit-text-stroke: 1px var(--lightgrey3, #ececec);
  margin: 0;
  flex: 1 1;
}

.modal-close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  font-size: 32px;
  font-weight: bold;
  color: var(--grey5, #727272);
  cursor: pointer;
  padding: 5px;
  line-height: 1;
  transition: color 0.2s ease;
}

.modal-close-btn:hover {
  color: var(--darkgrey3, #000000);
}

.modal-body {
  padding: 35px 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  width: 100%;
}

.modal-body-inner {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  width: 100%;
}

.option-row {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  justify-content: space-between; /* 좌우로 배치 */
  align-self: stretch;
  flex-shrink: 0;
  height: 53px;
  flex-wrap: nowrap; /* 1열 유지 */
  width: 100%;
  box-sizing: border-box;
}

.option-label {
  color: var(--darkgrey3, #000000);
  text-align: left;
  font-family: "Inter-Medium", sans-serif;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  min-width: 160px;
  max-width: 160px;
}

.option-value-box {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  height: 53px;
  padding: 0px 16px;
  border: none;
  border-radius: 0;
  background: transparent;
  flex: 1 1;
  min-width: 0;
  box-sizing: border-box;
}

.product-name-box {
  flex: 1 1;
  min-width: 0;
}

.product-code-box {
  flex: 1 1;
  min-width: 0;
}

.option-value {
  color: var(--grey5, #727272);
  text-align: left;
  font-family: "Inter-Regular", sans-serif;
  font-size: 18px;
  font-weight: 400;
}

.option-select-box {
  padding: 14px 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1;
  min-width: 0;
  height: 53px;
  box-sizing: border-box;
  position: relative;
}

.select-background {
  background: var(--white, #ffffff);
  border-radius: 5px;
  border: 1px solid var(--grey1, #d7d7d7);
  width: 100%;
  height: 53px;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 0;
}

.option-select-box select {
  width: 100%;
  border: none;
  background: none;
  font-family: "Inter-Medium", sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: var(--darkgrey3, #000000);
  appearance: none;
  cursor: pointer;
  z-index: 1;
  flex: 1 1;
  height: 25px;
}

.option-select-box select:focus {
  outline: none;
}

.select-arrow {
  border-radius: 0px;
  flex-shrink: 0;
  width: 19px;
  height: 19px;
  overflow: visible;
  z-index: 2;
  pointer-events: none;
}


.quantity-control-wrapper {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1;
  position: relative;
  min-width: 0;
  box-sizing: border-box;
}

.quantity-control {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
}

.quantity-control button {
  width: 33px;
  height: 33px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-icon {
  width: 33px;
  height: 33px;
  object-fit: contain;
}

.quantity-value-box {
  border-radius: 8px;
  border: 1px solid var(--grey2, #d9d9d9);
  padding: 5px 4px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 74.41px;
  height: 33px;
}

.quantity-value {
  color: var(--darkgrey3, #000000);
  text-align: center;
  font-family: "Inter-Regular", sans-serif;
  font-size: 18px;
  font-weight: 400;
}

.modal-footer {
  padding: 45px 60px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
}

.modal-footer button {
  padding: 0px 20px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  height: 53px;
  border: none;
  border-radius: 0;
  cursor: pointer;
  font-family: "Inter-Bold", sans-serif;
  font-size: 18px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-cancel {
  background: var(--darkgrey3, #000000);
  color: var(--white, #ffffff);
}

.btn-cancel div {
  color: var(--white, #ffffff);
  text-align: center;
  font-family: "Inter-Bold", sans-serif;
  font-size: 18px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.btn-detail {
  background: var(--grey5, #727272);
  color: var(--white, #ffffff);
}

.btn-detail div {
  color: var(--white, #ffffff);
  text-align: center;
  font-family: "Inter-Bold", sans-serif;
  font-size: 18px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.btn-add-to-cart {
  background: var(--primary, #e84200);
  color: var(--white, #ffffff);
}

.btn-add-to-cart div {
  color: var(--white, #ffffff);
  text-align: center;
  font-family: "Inter-Bold", sans-serif;
  font-size: 18px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

/* Mobile devices */
@media (max-width: 768px) {
    .modal-content {
        width: 95vw;
        max-width: 95vw;
    }
    
    .modal-header {
        width: 100%;
        height: auto;
        min-height: 80px;
        padding: 20px;
    }
    
    .modal-header h2 {
        font-size: 24px;
    }

    .modal-body {
        padding: 20px 10px;
        width: 100%;
    }
    
    .option-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        height: auto;
        min-height: 53px;
    }
    
    .option-label {
        width: 100%;
        margin-bottom: 5px;
    }
    
    .option-value-box,
    .option-select-box,
    .quantity-control-wrapper {
        width: 100%;
        box-sizing: border-box;
    }

    .product-code-box {
        width: 100%;
        flex: 1 1;
    }

    .option-select-box {
        width: 100%;
    }

    .select-background {
        width: 100%;
    }
    
    .modal-footer {
        flex-direction: column;
        padding: 20px;
        gap: 10px;
    }

    .modal-footer button {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/components/css/ProductModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mDAAmD;EACnD,SAAS;EACT,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8BAA8B,EAAE,WAAW;EAC3C,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB,EAAE,UAAU;EAC7B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAGhC,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,oBAAoB;AACtB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA,mBAAmB;AACnB;IACI;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;;;QAGI,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,SAAO;IACX;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[":root {\n  --primary: #e84200;\n  --grey1: #d7d7d7;\n  --grey2: #d9d9d9;\n  --grey5: #727272;\n  --darkgrey3: #000000;\n  --white: #ffffff;\n  --lightgrey2: #f1f1f1;\n  --lightgrey3: #ececec;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: var(--white, #ffffff);\n  width: 834px;\n  max-width: 90vw;\n  border-radius: 0;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n  align-items: flex-start;\n  justify-content: flex-start;\n  position: relative;\n}\n\n.modal-header {\n  background: var(--lightgrey2, #f1f1f1);\n  padding: 16px;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 100%;\n  height: 138px;\n  position: relative;\n  border-bottom: none;\n}\n\n.modal-header h2 {\n  color: var(--darkgrey3, #000000);\n  text-align: center;\n  font-family: \"Inter-Bold\", sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  -webkit-text-stroke: 1px var(--lightgrey3, #ececec);\n  margin: 0;\n  flex: 1;\n}\n\n.modal-close-btn {\n  position: absolute;\n  top: 15px;\n  right: 20px;\n  background: none;\n  border: none;\n  font-size: 32px;\n  font-weight: bold;\n  color: var(--grey5, #727272);\n  cursor: pointer;\n  padding: 5px;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.modal-close-btn:hover {\n  color: var(--darkgrey3, #000000);\n}\n\n.modal-body {\n  padding: 35px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.modal-body-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.option-row {\n  display: flex;\n  flex-direction: row;\n  gap: 15px;\n  align-items: center;\n  justify-content: space-between; /* 좌우로 배치 */\n  align-self: stretch;\n  flex-shrink: 0;\n  height: 53px;\n  flex-wrap: nowrap; /* 1열 유지 */\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.option-label {\n  color: var(--darkgrey3, #000000);\n  text-align: left;\n  font-family: \"Inter-Medium\", sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-shrink: 0;\n  min-width: 160px;\n  max-width: 160px;\n}\n\n.option-value-box {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: flex-start;\n  height: 53px;\n  padding: 0px 16px;\n  border: none;\n  border-radius: 0;\n  background: transparent;\n  flex: 1;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.product-name-box {\n  flex: 1;\n  min-width: 0;\n}\n\n.product-code-box {\n  flex: 1;\n  min-width: 0;\n}\n\n.option-value {\n  color: var(--grey5, #727272);\n  text-align: left;\n  font-family: \"Inter-Regular\", sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.option-select-box {\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  min-width: 0;\n  height: 53px;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.select-background {\n  background: var(--white, #ffffff);\n  border-radius: 5px;\n  border: 1px solid var(--grey1, #d7d7d7);\n  width: 100%;\n  height: 53px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  z-index: 0;\n}\n\n.option-select-box select {\n  width: 100%;\n  border: none;\n  background: none;\n  font-family: \"Inter-Medium\", sans-serif;\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--darkgrey3, #000000);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  cursor: pointer;\n  z-index: 1;\n  flex: 1;\n  height: 25px;\n}\n\n.option-select-box select:focus {\n  outline: none;\n}\n\n.select-arrow {\n  border-radius: 0px;\n  flex-shrink: 0;\n  width: 19px;\n  height: 19px;\n  overflow: visible;\n  z-index: 2;\n  pointer-events: none;\n}\n\n\n.quantity-control-wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1;\n  position: relative;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.quantity-control {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n  align-items: center;\n  justify-content: flex-start;\n  flex-shrink: 0;\n}\n\n.quantity-control button {\n  width: 33px;\n  height: 33px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.quantity-icon {\n  width: 33px;\n  height: 33px;\n  object-fit: contain;\n}\n\n.quantity-value-box {\n  border-radius: 8px;\n  border: 1px solid var(--grey2, #d9d9d9);\n  padding: 5px 4px;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 74.41px;\n  height: 33px;\n}\n\n.quantity-value {\n  color: var(--darkgrey3, #000000);\n  text-align: center;\n  font-family: \"Inter-Regular\", sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.modal-footer {\n  padding: 45px 60px;\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n  align-items: center;\n  justify-content: flex-start;\n  align-self: stretch;\n  flex-shrink: 0;\n}\n\n.modal-footer button {\n  padding: 0px 20px;\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  height: 53px;\n  border: none;\n  border-radius: 0;\n  cursor: pointer;\n  font-family: \"Inter-Bold\", sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.btn-cancel {\n  background: var(--darkgrey3, #000000);\n  color: var(--white, #ffffff);\n}\n\n.btn-cancel div {\n  color: var(--white, #ffffff);\n  text-align: center;\n  font-family: \"Inter-Bold\", sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.btn-detail {\n  background: var(--grey5, #727272);\n  color: var(--white, #ffffff);\n}\n\n.btn-detail div {\n  color: var(--white, #ffffff);\n  text-align: center;\n  font-family: \"Inter-Bold\", sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.btn-add-to-cart {\n  background: var(--primary, #e84200);\n  color: var(--white, #ffffff);\n}\n\n.btn-add-to-cart div {\n  color: var(--white, #ffffff);\n  text-align: center;\n  font-family: \"Inter-Bold\", sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .modal-content {\n        width: 95vw;\n        max-width: 95vw;\n    }\n    \n    .modal-header {\n        width: 100%;\n        height: auto;\n        min-height: 80px;\n        padding: 20px;\n    }\n    \n    .modal-header h2 {\n        font-size: 24px;\n    }\n\n    .modal-body {\n        padding: 20px 10px;\n        width: 100%;\n    }\n    \n    .option-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        height: auto;\n        min-height: 53px;\n    }\n    \n    .option-label {\n        width: 100%;\n        margin-bottom: 5px;\n    }\n    \n    .option-value-box,\n    .option-select-box,\n    .quantity-control-wrapper {\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    .product-code-box {\n        width: 100%;\n        flex: 1;\n    }\n\n    .option-select-box {\n        width: 100%;\n    }\n\n    .select-background {\n        width: 100%;\n    }\n    \n    .modal-footer {\n        flex-direction: column;\n        padding: 20px;\n        gap: 10px;\n    }\n\n    .modal-footer button {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
